export const PERMISSION = {
  ADD: 'REQUEST_PURCHASE_ORDER_ADD',
  EDIT: 'REQUEST_PURCHASE_ORDER_EDIT',
  REOPEN: 'REQUEST_PURCHASE_ORDER_REOPEN',
  VIEW: 'REQUEST_PURCHASE_ORDER_VIEW',
  REVIEW: 'REQUEST_PURCHASE_ORDER_REVIEW',
  DEL: 'REQUEST_PURCHASE_ORDER_DEL',
  PRINT: 'REQUEST_PURCHASE_ORDER_PRINT',
  ADD_REVIEW: 'REQUEST_PURCHASE_ORDER_ADD_REVIEW',
  DEL_REVIEW: 'REQUEST_PURCHASE_ORDER_DEL_REVIEW',
  ADD_PRODUCT: 'REQUEST_PURCHASE_ORDER_ADD_PRODUCT',
};

export const STATUS_ORDER = {
  NOTORDER: 0,
  ORDERED: 1,
  ALL: 2,
  NEEDS_ORDER: 3,
  PARTIAL: 4,
};

export const STATUS_ORDER_OPTIONS = [
  {
    label: 'Cần tạo đơn mua',
    value: STATUS_ORDER.NEEDS_ORDER,
  },
  {
    label: 'Đã tạo chưa đủ',
    value: STATUS_ORDER.PARTIAL,
  },
  {
    label: 'Đã tạo đủ',
    value: STATUS_ORDER.ORDERED,
  },
  {
    label: 'Chưa tạo đơn mua',
    value: STATUS_ORDER.NOTORDER,
  },
  {
    label: 'Tất cả',
    value: STATUS_ORDER.ALL,
  },
];

export const STATUS_REVIEW = {
  NOTREVIEW: 0, // không duyệt
  REVIEWED: 1, // đã duyệt
  REVIEWING: 2, // chưa duyệt
  ALL: 3,
};

export const STATUS_REVIEW_OPTIONS = [
  {
    label: 'Tất cả',
    value: STATUS_REVIEW.ALL,
  },
  {
    label: 'Đã duyệt',
    value: STATUS_REVIEW.REVIEWED,
  },
  {
    label: 'Chưa duyệt',
    value: STATUS_REVIEW.REVIEWING,
  },
  {
    label: 'Không duyệt',
    value: STATUS_REVIEW.NOTREVIEW,
  },
];

export const RP_STATUS = {
  WAITING: 1,
  REJECTED: 2,
  OVER_BUDGET: 3,
}

export const RP_STATUS_OPTIONS = [
  {
    label: 'Chờ đặt hàng',
    value: RP_STATUS.WAITING,
  },
  {
    label: 'Từ chối',
    value: RP_STATUS.REJECTED,
  },
  {
    label: 'Vượt ngân sách',
    value: RP_STATUS.OVER_BUDGET,
  },
]

export const APPROVE_STATUS = {
  REVIEWED : 1,
  NOTREVIEW : 0,
  NOTYETREVIEW : 2
};

export const ORDER_STATUS = {
  ORDERED : 'Đã tạo đơn mua',
  NOTYETORDER : 'Chưa tạo đơn mua',
};
